import { clients } from "../../helpers/backend_helper";
import { DELETE_CLIENT_FAILED, DELETE_CLIENT_SUCCESSFUL, FETCH_CLIENTS_FAILED, FETCH_CLIENTS_SUCCESSFUL, REGISTER_CLIENT_FAILED, REGISTER_CLIENT_SUCCESSFUL, UPDATE_CLIENT_FAILED, UPDATE_CLIENT_SUCCESSFUL } from "./actionTypes";

// 🔹 Fetch all clients
export const fetchClients = () => async (dispatch) => {
  try {
    const response = await clients({ act: "client", subact: "getAll" });

    if (response.data) {
      dispatch({
        type: FETCH_CLIENTS_SUCCESSFUL,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_CLIENTS_FAILED,
        payload: "Failed to fetch clients",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_CLIENTS_FAILED,
      payload: "Error while fetching clients",
    });
  }
};

// 🔹 Register a new client
export const registerClient = (data) => async (dispatch) => {
  try {
    const response = await clients({
      act: "client",
      subact: "create",
      info: data,
    });

    if (response.message.includes("success")) {
      dispatch({
        type: REGISTER_CLIENT_SUCCESSFUL,
        payload: response,
      });
    } else {
      dispatch({
        type: REGISTER_CLIENT_FAILED,
        payload: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: REGISTER_CLIENT_FAILED,
      payload: "Error while registering client",
    });
  }
};

// 🔹 Update client details
export const updateClient = (data) => async (dispatch) => {
  try {
    const response = await clients({
      act: "client",
      subact: "update",
      info: data,
    });

    if (response.message.includes("success")) {
      dispatch({
        type: UPDATE_CLIENT_SUCCESSFUL,
        payload: response,
      });
      dispatch(fetchClients()); // Refresh client list
    } else {
      dispatch({
        type: UPDATE_CLIENT_FAILED,
        payload: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_CLIENT_FAILED,
      payload: "Error while updating client",
    });
  }
};

// 🔹 Delete a client
export const deleteClient = (clientId) => async (dispatch) => {
  try {
    const response = await clients({
      act: "client",
      subact: "delete",
      info: { clientId },
    });

    if (response.message.includes("success")) {
      dispatch({
        type: DELETE_CLIENT_SUCCESSFUL,
        payload: clientId,
      });
    } else {
      dispatch({
        type: DELETE_CLIENT_FAILED,
        payload: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: DELETE_CLIENT_FAILED,
      payload: "Error while deleting client",
    });
  }
};
